import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Advisory } from './models/advisory';
import { ConfigService } from './config.service';

export type AdvisoryApiType = 'WQ' | 'CSO';

@Injectable({ providedIn: 'root' })
export class AdvisoryService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(ConfigService);

  getAdvisories(advisoryType: AdvisoryApiType, occurredOn?: Date): Observable<Advisory[]> {
    const params: Record<string, string> = { advisoryType };
    if (occurredOn) {
      params['occurredOn'] = occurredOn.toISOString();
    }
    return this.http.get<Advisory[]>(`${this.config.apiBase}/advisory`, { params });
  }
}
